import { Text, type TextProps } from 'react-native';

import { useThemeColor } from '@/hooks/use-theme-color';

export type ThemedTextProps = TextProps & {
  className?: string;
  type?: 'default' | 'title' | 'subtitle' | 'semibold' | 'link' | 'muted';
};

const typeClasses: Record<NonNullable<ThemedTextProps['type']>, string> = {
  default: 'text-base leading-6',
  title: 'font-serif-bold text-3xl',
  subtitle: 'font-serif-semibold text-xl',
  semibold: 'text-base leading-6 font-semibold',
  link: 'text-base leading-8',
  muted: 'text-sm',
};

const typeColorName: Record<
  NonNullable<ThemedTextProps['type']>,
  'text' | 'textMuted' | 'accent'
> = {
  default: 'text',
  title: 'text',
  subtitle: 'text',
  semibold: 'text',
  link: 'accent',
  muted: 'textMuted',
};

export function ThemedText({ className = '', type = 'default', style, ...rest }: ThemedTextProps) {
  const color = useThemeColor({}, typeColorName[type]);

  return (
    <Text className={`${typeClasses[type]} ${className}`} style={[{ color }, style]} {...rest} />
  );
}
